import { createActions, createReducer } from 'reduxsauce';
import { schema } from 'normalizr';
import {
  EXTEND_NORMALIZED_INITIAL_STATE,
  PAGINATED_ACTIONS_SET,
  getRequestHandler,
  getExtendNormalized,
  getSuccessListHandler,
  getFailureHandler,
} from '../../../store/structures';

const appliedCoupon = new schema.Entity('appliedCoupons');

export const { Types: types, Creators: actions } = createActions(
  {
    getApplyCouponList: ['params'],
    // Added on web port: mobile's cancelApplied/saga.js dispatches
    // `updateAppliedCoupon(id, data)` after a cancel request resolves, but
    // that action didn't exist on the mobile duck — calling it would throw.
    // Defined here (and handled below) so cancelling an applied coupon
    // correctly updates this list's normalized `items` entry.
    updateAppliedCoupon: ['id', 'data'],
    ...PAGINATED_ACTIONS_SET,
  },
  { prefix: 'cb/coupons/applied/' },
);
export const HANDLERS = {
  [types.REQUEST]: getRequestHandler(EXTEND_NORMALIZED_INITIAL_STATE),
  [types.SUCCESS]: (state, action) => {
    const next = getExtendNormalized(getSuccessListHandler, appliedCoupon)(state, action);
    return next;
  },
  [types.SUCCESS_PAGINATED]: (state, action) => {
    const next = getExtendNormalized(getSuccessListHandler, appliedCoupon, { attach: true })(state, action);
    return next;
  },
  [types.FAILURE]: getFailureHandler(),
  [types.UPDATE_APPLIED_COUPON]: (state, { id, data }) => ({
    ...state,
    items: {
      ...state.items,
      [id]: {
        ...state.items[id],
        ...data,
      },
    },
  }),
};

export default createReducer(EXTEND_NORMALIZED_INITIAL_STATE, HANDLERS);
